import { PayloadAction, SliceCaseReducers, SliceSelectors, createSlice } from '@reduxjs/toolkit';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { catalogItemReducerPath } from './const';

type CatalogItemType = CatalogItemViewModel | null | undefined;
const initState: CatalogItemType = null;

export const catalogItemSlice = createSlice<CatalogItemType, SliceCaseReducers<CatalogItemType>, string, SliceSelectors<unknown>>({
  name: catalogItemReducerPath,
  initialState: initState,
  reducers: {
    setCatalogItem(_state, action: PayloadAction<CatalogItemType>) {
      return action.payload || null;
    },
  },
});

export const catalogItemConfig = {
  [catalogItemReducerPath]: catalogItemSlice.reducer,
};
